var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakersVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2D2D2D;}\n\t.st1{fill:none;stroke:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9,6.8l9,5.2l-9,5.2V6.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakersVideo);
export default __webpack_public_path__ + "static/media/speakers-video.c5d4cb528da42051b80a4ccae13abdc9.svg";
export { ForwardRef as ReactComponent };